module.exports = __webpack_public_path__ + "img/birthplace-logo-white.461dc81f.png";